import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';

export const VendorHeader = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.14),
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const FormContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(1),
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(-1),
}));

export const VendorInfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const VendorLabel = styled(Typography)({
  textTransform: 'uppercase',
  fontWeight: 600,
  letterSpacing: 0.5,
  display: 'block',
});

export const AccountsChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export const DefaultToggleBox = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
}));

export const DefaultLabelContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}));

export const DefaultStarIcon = styled(StarIcon, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  color: active ? theme.palette.warning.main : theme.palette.action.disabled,
  marginTop: '2px',
  flexShrink: 0,
}));

export const DefaultFormControlLabel = styled(FormControlLabel)({
  marginLeft: 0,
  marginRight: 0,
  justifyContent: 'space-between',
  width: '100%',
});

export const FormActions = styled(DialogActions)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(2),
}));
